<form
  class="key-test-form"
  [formGroup]="keyTestForm()"
>
  @for (row of keyTestRowFormFields; track $index) {
    <div
      class="key-test-row"
      [class]="row.className || ''"
    >
      @if (row.labelRow) {
        <div class="key-test-row-label">
          {{ row.labelRow }}
        </div>
      }
      @for (field of row.fields; track $index) {
        @switch (field.type) {
          @case ('number') {
            <mat-form-field
              appearance="outline"
              [class]="getFieldClass()"
            >
              <mat-label>
                {{ field.label }}
              </mat-label>
              <input
                #inputElement
                matInput
                appDecimalLimit
                [decimals]="field.decimals || 0"
                [type]="field.type"
                inputmode="decimal"
                [formControlName]="field.fieldName"
                (blur)="handleValueChange(field.fieldName, inputElement.value)"
              >
            </mat-form-field>
          }
          @case ('textarea') {
            <mat-form-field
              appearance="outline"
              [class]="getFieldClass()"
            >
              <mat-label>
                {{ field.label }}
              </mat-label>
              <textarea
                matInput
                cdkTextareaAutosize
                type="text"
                cdkAutosizeMinRows="4"
                cdkAutosizeMaxRows="4"
                [formControlName]="field.fieldName"
                (blur)="handleValueChange(field.fieldName)"
              ></textarea>
            </mat-form-field>
          }
          @case ('text') {
            <mat-form-field
              appearance="outline"
              [class]="getFieldClass()"
            >
              <mat-label>
                {{ field.label }}
              </mat-label>
              <input
                matInput
                type="text"
                [formControlName]="field.fieldName"
                (blur)="handleValueChange(field.fieldName)"
              >
            </mat-form-field>
          }
          @case ('date') {
            <mat-form-field
              appearance="outline"
              [class]="getFieldClass()"
            >
              <mat-label>
                {{ field.label }}
              </mat-label>
              <input
                matInput
                appDateInput
                placeholder="ДД.ММ.ГГГГ"
                [matDatepicker]="datePicker"
                [min]="minDate"
                [formControlName]="field.fieldName"
                (dateChange)="handleDateChange($event.value, field.fieldName)"
              >
              <mat-datepicker-toggle
                matSuffix
                [for]="datePicker"
              />
              <mat-datepicker #datePicker/>
            </mat-form-field>
          }
          @case ('time') {
            <mat-form-field
              appearance="outline"
              [class]="getFieldClass()"
            >
              <mat-label>
                {{ field.label }}
              </mat-label>
              <input
                matInput
                placeholder="ЧЧ:ММ"
                [matTimepicker]="timePicker"
                [formControlName]="field.fieldName"
              >
              <mat-timepicker-toggle
                matSuffix
                [for]="timePicker"
              />
              <mat-timepicker
                #timePicker
                interval="15min"
                (closed)="handleTimeChange(field.fieldName)"
              />
            </mat-form-field>
          }
        }
      }
    </div>
  }
  @if (!keyTestData().id) {
    <div class="buttons-container">
      @if (noFirstData()) {
        <button
          mat-button
          color="warn"
          (click)="handleDeleteData()"
        >
          Удалить
        </button>
      }
      <button
        mat-button
        color="primary"
        [disabled]="keyTestForm().invalid"
        (click)="handleCreateData()"
      >
        Сохранить
      </button>
    </div>
  }
</form>
